import { render } from "./banque.vue?vue&type=template&id=c8129a6e&scoped=true"
import script from "./banque.vue?vue&type=script&lang=js"
export * from "./banque.vue?vue&type=script&lang=js"

import "./banque.vue?vue&type=style&index=0&id=c8129a6e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8129a6e"]])

export default __exports__